import React, { Component } from "react";

export class Header extends Component {
  render() {
    return (
      <header id="header">
        <div className="intro" 
          // style={{width:"100%",position:"relative",display: "inline-block"}}
        >
          {/* <div className="top-overlay" style={{position:"absolute",top: "0px", left:"0px", width:"100%", height:"auto"}}>
            <img style={{width:"100%", height:"auto"}} src="img/imagenes_llucmajor/medico_grande.png" alt=""/>
          </div> */}
          <div className="overlay" style={{
                    // backgroundColor:"blue", opacity:0.6
                  }}>
            <div className="container">
              <div className="row" >
                <div className="col-md-8 col-md-offset-2 intro-text">
                  <h1>
                    {this.props.data ? this.props.data.title : "Loading"}
                    <span></span>
                  </h1>
                    {this.props.data ? this.props.data.paragraph.map((t,i)=>(
                          <p key={`text-${i}`}>{t}</p>
                        )) : "Loading"}
                  
                  {/* <a
                    href="#features"
                    className="btn btn-custom btn-lg page-scroll"
                  >
                    Learn More
                  </a> */}
                  {" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
